import React from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router';

import {TPeriodPickerValue} from '@edna/components';
import {getPeriod} from '@edna/utils';

import {TItemId} from 'src/constants';
import PATHS from 'src/paths';

import {LIST_CONFIG} from '../definitions';
import {setFiltersAction} from '../slice';

export type TNavigateToReportByBroadcastId = {
  period?: TPeriodPickerValue;
  broadcastId?: TItemId;
};

export const useNavigateToReportByBroadcastId = ({
  period,
  broadcastId,
}: TNavigateToReportByBroadcastId) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return React.useCallback(async () => {
    if (!broadcastId) {
      return;
    }

    dispatch(
      setFiltersAction({
        ...LIST_CONFIG.filtersConfig.defaultFilters,
        broadcasts: [Number(broadcastId)],
        period: period ? period : getPeriod('hours24'),
      }),
    );

    navigate(PATHS.ANALYTICS_MESSAGES);
  }, [broadcastId, dispatch, navigate, period]);
};
